import { types } from 'mobx-state-tree';

const FixedProfit = types.model('FixedProfit', {
  profit: types.optional(types.number, 0),
  breakEven: types.optional(types.number, 0),
  // fixedFee: types.maybe(types.number),
  inPercents: types.optional(types.boolean, false),
});

const Competition = types.model('Competition', {
  minimalProfit: types.optional(types.number, 0),
  optimalProfit: types.optional(types.number, 0),
  breakEven: types.optional(types.number, 0),
  inPercents: types.optional(types.boolean, false),
});

const Penetration = types.model('Penetration', {
  minimalProfit: types.optional(types.number, 0),
  maximalProfit: types.optional(types.number, 0),
  upTimes: types.optional(types.number, 0),
  up: types.optional(types.number, 0),
  downDays: types.optional(types.number, 0),
  down: types.optional(types.number, 0),
  breakEven: types.optional(types.number, 0),
  inPercents: types.optional(types.boolean, false),
});

const PricingStrategy = types.model('PricingStrategy', {
  fixedProfit: types.optional(FixedProfit, {}),
  competition: types.optional(Competition, {}),
  penetration: types.optional(Penetration, {}),
});

export default PricingStrategy;
